import { FC, ReactNode } from 'react';

import { default as NextLink, LinkProps } from 'next/link';
import styled from 'styled-components';

interface RouterLinkProps extends Omit<LinkProps, 'as'> {
  children: ReactNode;
  className?: string;
  dark?: boolean;
  darkHover?: boolean;
}

const StyledLink = styled(NextLink)<RouterLinkProps>`
  color: ${({ theme, dark }) => (dark ? theme.colors.text01 : theme.colors.interactivePrimary01)};
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    ${({ theme, darkHover }) => (darkHover ? `color: ${theme.colors.text01}` : '')}
  }
`;

const RouterLink: FC<RouterLinkProps> = ({ href, children, className, ...htmlProps }) => (
  <StyledLink href={href} passHref {...htmlProps} className={className}>
    {children}
  </StyledLink>
);

export default RouterLink;
